import { createContext } from "react";

export const KpointPlayerContext = createContext({
    players:[],
    isMuteRef: false,
    addPlayer: (player) => {},
    removePlayer: (player) => {},
});
